import { render } from "./elem-textarea.vue?vue&type=template&id=bc395fd6&ts=true"
import script from "./elem-textarea.vue?vue&type=script&lang=ts"
export * from "./elem-textarea.vue?vue&type=script&lang=ts"

import "./elem-textarea.vue?vue&type=style&index=0&id=bc395fd6&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__